import React, { memo } from 'react';
import { withBlokWrapper } from '../../BlokWrapper/BlokWrapper';
import { Theme } from '../../../interfaces/enums/Theme.enum';
import QuoteTabBarLoadingState from '../../QuoteFormTabBar/QuoteTabBarLoadingState';
import QuoteStageMainLayoutLoadingState from '../QuoteStageMainLayout/QuoteStageMainLayoutLoadingState';
import QuoteDetailsLoadingState from '../QuoteStageBloks/QuoteDetails/QuoteDetailsLoadingState';
import QuoteMoveSpecialistLoadingState from '../QuoteStageBloks/QuoteMoveSpecialist/QuoteMoveSpecialistLoadingState';
import PersonalDetailsReviewAndEditFormSectionLoadingState from '../../QuoteFormSections/PersonalDetailsReviewAndEditFormSection/PersonalDetailsReviewAndEditFormSectionLoadingState';
import FormSectionLoadingState from '../../QuoteFormSections/FormSection/FormSectionLoadingState';
import FormFieldTextInputLoadingState from '../../FormFields/FormFieldTextInput/FormFieldTextInputLoadingState';
import QuoteTotalTermsAndButtonsLoadingState from '../QuoteStageBloks/QuoteTotalTermsAndButtons/QuoteTotalTermsAndButtonsLoadingState';

const QuoteStageThreePageLoadingState: React.FC = () => {
  return (
    <div>
      <QuoteTabBarLoadingState />
      <QuoteStageMainLayoutLoadingState
        leftColumn={
          <div className="w-full">
            <PersonalDetailsReviewAndEditFormSectionLoadingState />
            <FormSectionLoadingState>
              <FormFieldTextInputLoadingState />
            </FormSectionLoadingState>
            <QuoteTotalTermsAndButtonsLoadingState />
          </div>
        }
        rightColumn={
          <div className="xl:space-y-8">
            <QuoteDetailsLoadingState />
            <QuoteMoveSpecialistLoadingState />
          </div>
        }
      />
    </div>
  );
};

export default memo(
  withBlokWrapper(QuoteStageThreePageLoadingState, Theme.LIGHT)
);
